import { useState } from 'react';
import { motion } from 'framer-motion';
import PresupuestoModal from '../../../components/base/PresupuestoModal';

const HeroSection = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <section className="relative min-h-screen flex items-center overflow-hidden pt-20 md:pt-0 pb-48 md:pb-24">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage:
              'url(https://public.readdy.ai/ai/img_res/d6d9b930d08042ef5e8bdb4c54f1d683.jpg)',
          }}
        >
          <link
            rel="preload"
            as="image"
            href="https://readdy.ai/api/search-image?query=Empty%20bright%20apartment%20interior%20Barcelona%20with%20wooden%20floors%20white%20walls%20large%20windows%20natural%20light&width=1920&height=1080&seq=hero-home-bg-002&orientation=landscape"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-br from-navy/85 via-navy/60 to-transparent" />

        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="max-w-2xl">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <span className="inline-block bg-orange text-white text-sm font-medium px-4 py-2 rounded-full mb-4">
                Servicio profesional en Barcelona
              </span>
              <h1 className="text-5xl md:text-6xl font-extrabold text-white leading-tight mb-6">
                Vaciado de pisos y locales en{' '}
                <span className="italic font-normal">Barcelona</span>
              </h1>
              <p className="text-xl text-white/90 font-light leading-relaxed mb-10 max-w-lg">
                Retirada completa de muebles y enseres. Servicio rápido, discreto y con gestión responsable de residuos. Entregamos tu inmueble listo para reforma, venta o alquiler.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 mb-32 md:mb-0">
                <a
                  href="https://wa.me/34629501941"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center bg-orange text-white text-base font-medium px-8 py-4 rounded-full hover:bg-orange-light hover:scale-105 transition-all shadow-lg whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-xl mr-2"></i>
                  Enviar fotos por WhatsApp
                </a>
                <button
                  onClick={() => setShowModal(true)}
                  className="inline-flex items-center justify-center border-2 border-white bg-transparent text-white text-base font-medium px-8 py-4 rounded-full hover:bg-white hover:text-navy transition-all whitespace-nowrap cursor-pointer"
                >
                  Pedir visita y presupuesto
                </button>
              </div>
            </motion.div>
          </div>
        </div>

        <div className="absolute bottom-6 md:bottom-16 left-0 right-0 z-10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-wrap justify-center gap-3">
              {[
                { icon: 'ri-recycle-line', text: 'Gestión responsable' },
                { icon: 'ri-shield-check-line', text: 'Servicio discreto' },
                { icon: 'ri-map-pin-line', text: 'Cobertura Barcelona' },
              ].map((badge, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.8 + index * 0.1 }}
                  className="flex items-center gap-2 bg-white/15 backdrop-blur-md text-white px-5 py-3 rounded-full"
                >
                  <i className={`${badge.icon} text-lg`}></i>
                  <span className="text-sm font-medium">{badge.text}</span>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <PresupuestoModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </>
  );
};

export default HeroSection;
